/* Thryve X interactions + scroll motion. Every section works without JS;
   motion only starts when GSAP is present and the visitor allows motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.hasAttribute('data-tx-still');
  var hasGsap = function () { return !reduce && window.gsap && window.ScrollTrigger; };
  var $$ = function (root, s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  /* header: scroll progress, compact state, menu drawer */
  function initHeader() {
    var hdr = document.querySelector('[data-tx-header]');
    if (!hdr || hdr.dataset.ready) return;
    hdr.dataset.ready = '1';
    var prog = hdr.querySelector('.tx-prog');
    var onScroll = function () {
      var h = document.documentElement.scrollHeight - innerHeight;
      if (prog) prog.style.transform = 'scaleX(' + (h > 0 ? scrollY / h : 0) + ')';
      hdr.classList.toggle('is-small', scrollY > 40);
    };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var menu = document.querySelector('[data-tx-menu]');
    if (!menu) return;
    var open = function (v) {
      menu.classList.toggle('is-open', v);
      document.documentElement.style.overflow = v ? 'hidden' : '';
      menu.setAttribute('aria-hidden', v ? 'false' : 'true');
    };
    $$(document, '[data-tx-menu-open]').forEach(function (b) { b.addEventListener('click', function () { open(true); }); });
    $$(menu, '[data-tx-menu-close]').forEach(function (b) { b.addEventListener('click', function () { open(false); }); });
    menu.addEventListener('click', function (e) { if (e.target === menu) open(false); });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
  }

  /* product gallery + thumbnails */
  function initGallery(root) {
    $$(root, '[data-tx-gallery]').forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var gal = wrap.querySelector('.tx-gal');
      var count = wrap.querySelector('.tx-gal-count');
      var thumbs = $$(wrap.parentElement, '.tx-thumbs button');
      var n = gal.children.length, last = 0;
      var set = function (i) {
        thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); });
        if (count) count.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
        var t = thumbs[i];
        if (t) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.offsetWidth / 2 + 29, behavior: 'smooth' });
      };
      gal.addEventListener('scroll', function () {
        var i = Math.round(gal.scrollLeft / gal.offsetWidth);
        if (i !== last) { last = i; set(i); }
      }, { passive: true });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { gal.scrollTo({ left: i * gal.offsetWidth, behavior: 'smooth' }); }); });
    });
  }

  /* sticky add-to-cart bar */
  function initSticky(root) {
    $$(root, '[data-tx-sticky]').forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      var target = document.getElementById(bar.dataset.txSticky);
      if (!target) return;
      var ticking = false;
      var check = function () {
        ticking = false;
        var r = target.getBoundingClientRect();
        bar.classList.toggle('is-show', r.bottom < 0);
      };
      addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      check();
    });
    $$(root, '[data-tx-go-buy]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var el = document.querySelector('.tx-buy');
        if (el) { e.preventDefault(); el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); }
      });
    });
    $$(root, '[data-tx-go]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var el = document.getElementById(b.dataset.txGo);
        if (el) { e.preventDefault(); el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
      });
    });
  }

  /* decline chart: compound % per year from start to end age */
  function initChart(root) {
    $$(root, '[data-tx-chart]').forEach(function (fig) {
      if (fig.dataset.ready) return;
      fig.dataset.ready = '1';
      var rate = parseFloat(fig.dataset.rate) / 100, a0 = +fig.dataset.from, a1 = +fig.dataset.to;
      var curve = fig.querySelector('.c-line'), fill = fig.querySelector('.c-fill'), dot = fig.querySelector('.c-dot'), lbl = fig.querySelector('.c-lbl');
      var minV = Math.pow(1 - rate, a1 - a0), floor = Math.max(0, Math.floor(minV * 4) / 4);
      var X = function (a) { return 40 + (a - a0) * (290 / (a1 - a0)); };
      var Y = function (v) { return 21 + (1 - v) / (1 - floor) * 150; };
      var d = '';
      for (var a = a0; a <= a1; a++) d += (a === a0 ? 'M' : ' L') + X(a).toFixed(1) + ' ' + Y(Math.pow(1 - rate, a - a0)).toFixed(1);
      curve.setAttribute('d', d);
      fill.setAttribute('d', d + ' L' + X(a1) + ' 171 L' + X(a0) + ' 171 Z');
      $$(fig, '[data-y]').forEach(function (t) {
        var v = 1 - (1 - floor) * (+t.dataset.y);
        t.textContent = Math.round(v * 100) + '%';
      });
      $$(fig, '[data-x]').forEach(function (t) { t.textContent = Math.round(a0 + (a1 - a0) * (+t.dataset.x)); });
      var len = curve.getTotalLength();
      curve.style.strokeDasharray = len;
      var set = function (t) {
        curve.style.strokeDashoffset = len * (1 - t);
        var p = curve.getPointAtLength(len * t);
        dot.setAttribute('cx', p.x); dot.setAttribute('cy', p.y);
        var age = Math.round(a0 + (a1 - a0) * t);
        lbl.textContent = 'AGE ' + age + ' · ' + Math.round(Math.pow(1 - rate, age - a0) * 100) + '%';
        lbl.setAttribute('x', Math.min(p.x + 8, 244)); lbl.setAttribute('y', p.y - 10);
        fill.style.opacity = t;
      };
      set(1);
      if (!hasGsap()) return;
      var st = { t: 0 }; set(0);
      gsap.to(st, { t: 1, ease: 'none', onUpdate: function () { set(st.t); }, scrollTrigger: { trigger: fig, start: 'top 85%', end: 'bottom 45%', scrub: 0.6 } });
    });
  }

  /* benefit rows light up as they cross the middle of the screen */
  function initLit(root) {
    $$(root, '.tx-lit').forEach(function (lit) {
      if (lit.dataset.ready) return;
      lit.dataset.ready = '1';
      var rows = $$(lit, '.tx-lit-row');
      if (reduce) { rows.forEach(function (r) { r.classList.add('is-on'); }); return; }
      lit.classList.add('js-lit');
      var io = lit._txIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.target.classList.toggle('is-on', e.isIntersecting); });
      }, { rootMargin: '-38% 0px -38% 0px' });
      rows.forEach(function (r) { io.observe(r); });
    });
  }

  /* GSAP motion, scoped per section */
  function initMotion(root) {
    if (!hasGsap()) return;
    gsap.registerPlugin(ScrollTrigger);
    var once = function (el) { if (el.dataset.txAnim) return false; el.dataset.txAnim = '1'; return true; };

    $$(root, '[data-tx-count]').forEach(function (el) {
      if (!once(el)) return;
      var to = parseFloat(el.dataset.txCount), dec = +(el.dataset.dec || 0), o = { v: 0 };
      gsap.to(o, { v: to, duration: 1.4, ease: 'power3.out', onUpdate: function () { el.textContent = dec ? o.v.toFixed(dec) : Math.round(o.v); }, scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
    });
    $$(root, '.tx-band>.tx-wrap>h2,.tx-made h2,.tx-final .tx-wrap>h2').forEach(function (h) {
      if (!once(h)) return;
      gsap.from(h, { y: 26, opacity: 0.2, duration: 0.8, ease: 'power3.out', scrollTrigger: { trigger: h, start: 'top 90%' } });
    });
    $$(root, '.tx-swipe').forEach(function (s) {
      if (!once(s)) return;
      gsap.from(s.children, { x: 70, opacity: 0.3, stagger: 0.1, duration: 0.8, ease: 'power3.out', scrollTrigger: { trigger: s, start: 'top 88%' } });
    });
    $$(root, '.tx-ings').forEach(function (g) {
      if (!once(g)) return;
      gsap.from(g.children, { y: 40, opacity: 0.2, scale: 0.96, stagger: 0.08, duration: 0.7, ease: 'power3.out', scrollTrigger: { trigger: g, start: 'top 85%' } });
      $$(g, '.tx-ing-ph img').forEach(function (im) {
        gsap.fromTo(im, { rotation: -8, scale: 1.2 }, { rotation: 0, scale: 1, ease: 'none', scrollTrigger: { trigger: im, start: 'top bottom', end: 'center 45%', scrub: true } });
      });
    });
    $$(root, '.tx-glow').forEach(function (gl) {
      if (!once(gl)) return;
      gsap.fromTo(gl, { yPercent: -25, scale: 0.85 }, { yPercent: 35, scale: 1.15, ease: 'none', scrollTrigger: { trigger: gl.parentElement, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    $$(root, '.tx-tl').forEach(function (tl) {
      if (!once(tl)) return;
      gsap.fromTo(tl.querySelector('.tx-tl-fill'), { scaleY: 0 }, { scaleY: 1, ease: 'none', scrollTrigger: { trigger: tl, start: 'top 70%', end: 'bottom 60%', scrub: 0.4 } });
      $$(tl, '.tx-tl-item').forEach(function (it) {
        gsap.from(it.querySelector('.tx-tl-dot'), { scale: 0.4, duration: 0.5, scrollTrigger: { trigger: it, start: 'top 70%', toggleActions: 'play none none reverse' } });
        gsap.from(it.querySelectorAll('.tx-tl-day,h3,p'), { x: 20, opacity: 0.25, stagger: 0.08, duration: 0.6, scrollTrigger: { trigger: it, start: 'top 75%' } });
        var im = it.querySelector('img');
        if (im) gsap.fromTo(im, { scale: 1.12 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: im, start: 'top bottom', end: 'bottom top', scrub: true } });
      });
    });
    $$(root, '.tx-flow').forEach(function (flow) {
      if (!once(flow)) return;
      gsap.to(flow.querySelector('.tx-pulse'), { y: function () { return flow.offsetHeight - 52; }, ease: 'none', scrollTrigger: { trigger: flow, start: 'top 65%', end: 'bottom 55%', scrub: 0.5, invalidateOnRefresh: true } });
      $$(flow, '.tx-node').forEach(function (nd) {
        gsap.from(nd.querySelector('.tx-orb'), { scale: 0.6, duration: 0.6, ease: 'back.out(2)', scrollTrigger: { trigger: nd, start: 'top 65%' } });
      });
    });
    $$(root, '.tx-cmp').forEach(function (t) {
      if (!once(t)) return;
      gsap.from(t.querySelectorAll('.tx-yes'), { scale: 0, rotation: -90, stagger: 0.12, duration: 0.45, ease: 'back.out(2)', scrollTrigger: { trigger: t, start: 'top 70%' } });
      gsap.from(t.querySelectorAll('.tx-no'), { scale: 0, stagger: 0.12, duration: 0.4, delay: 0.3, scrollTrigger: { trigger: t, start: 'top 70%' } });
    });
    $$(root, '.tx-made').forEach(function (m) {
      if (!once(m)) return;
      var im = m.querySelector(':scope > img');
      if (im) gsap.fromTo(im, { yPercent: -6 }, { yPercent: 6, ease: 'none', scrollTrigger: { trigger: m, start: 'top bottom', end: 'bottom top', scrub: true } });
      gsap.from(m.querySelectorAll('.tx-words span'), { y: 14, opacity: 0.2, stagger: 0.07, duration: 0.5, scrollTrigger: { trigger: m, start: 'top 60%' } });
    });
    $$(root, '.tx-seal svg').forEach(function (s) {
      if (!once(s)) return;
      gsap.to(s, { rotation: 180, ease: 'none', scrollTrigger: { trigger: s, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    $$(root, '[data-tx-words] .tx-sw-word').forEach(function (w) {
      if (!once(w)) return;
      var o = { f: 0 }; w.style.setProperty('--fill', '0%');
      gsap.to(o, { f: 100, ease: 'none', onUpdate: function () { w.style.setProperty('--fill', o.f + '%'); },
        scrollTrigger: { trigger: w, start: 'top 85%', end: 'top 40%', scrub: 0.4 } });
      gsap.fromTo(w, { x: -24 }, { x: 0, ease: 'none', scrollTrigger: { trigger: w, start: 'top bottom', end: 'top 40%', scrub: true } });
    });
    $$(root, '[data-tx-bar]').forEach(function (b) {
      if (!once(b)) return;
      gsap.fromTo(b, { scaleX: 1 }, { scaleX: (+b.dataset.txBar || 40) / 100, duration: 1.6, ease: 'power2.out', scrollTrigger: { trigger: b, start: 'top 90%' } });
    });
    ScrollTrigger.refresh();
  }

  /* keep one-line titles inside their box */
  function fitTitles(root) {
    $$(root, '.tx-buy h1:not(.is-long)').forEach(function (h) {
      h.style.fontSize = '';
      var fs = parseFloat(getComputedStyle(h).fontSize);
      while (h.scrollWidth > h.clientWidth + 1 && fs > 16) { fs -= 0.5; h.style.fontSize = fs + 'px'; }
    });
  }

  /* load section background photos only when they come near the screen */
  function initBg(root) {
    var els = $$(root, '[data-tx-bg]');
    if (!els.length) return;
    var set = function (el) { el.style.setProperty(el.dataset.txBg, el.dataset.src); el.removeAttribute('data-tx-bg'); };
    if (!('IntersectionObserver' in window)) { els.forEach(set); return; }
    var io = window._txBgIO || (window._txBgIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); set(e.target); } });
    }, { rootMargin: '800px 0px' }));
    els.forEach(function (el) { io.observe(el); });
  }

  function init(root) {
    root = root || document;
    initBg(root);
    fitTitles(root);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitTitles(root); });
    initHeader();
    initGallery(root);
    initSticky(root);
    initChart(root);
    initLit(root);
    initMotion(root);
  }

  addEventListener('resize', function () { fitTitles(document); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* theme editor: re-run when a section is added or changed */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
